const mitsubishi = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Mirage G4",
          sideView: require("../../../static/images/carcuts/mitsubishi/side-view/mirage-g4-red-compressor.png"),
          angleView: require("../../../static/images/carcuts/mitsubishi/angle-view/mirage-g4-19.png"),
          trims: ["ES 5MT", "ES CVT", "LE", "SE", "BE"]
        },
        {
          modelName: "Mirage Hatchback",
          sideView: require("../../../static/images/carcuts/mitsubishi/side-view/mirage-hatchback-red-compressor.png"),
          angleView: require("../../../static/images/carcuts/mitsubishi/angle-view/mirage-se-19.png"),
          trims: ["ES 5MT", "ES CVT", "LE", "SE", "BE"]
        },
      ],
      suvs: [
        {
          modelName: "Eclipse Cross",
          sideView: require("../../../static/images/carcuts/mitsubishi/side-view/eclipse-cross-red-compressor.png"),
          angleView: require("../../../static/images/carcuts/mitsubishi/angle-view/eclipsecross-19.png"),
          trims: ["ES", "LE", "SE", "SE Package", "SEL", "SEL Touring"]
        },
        {
          modelName: "Outlander",
          sideView: require("../../../static/images/carcuts/mitsubishi/side-view/outlander-es-red-compressor.png"),
          angleView: require("../../../static/images/carcuts/mitsubishi/angle-view/outlander-18.png"),
          trims: ["ES 2.5 2WD", "Black Edition", "SE 2.5 2WD", "SE Tech", "SE Special Edition", "SEL", "SEL Touring"]
        },
        {
          modelName: "Outlander Sport",
          sideView: require("../../../static/images/carcuts/mitsubishi/side-view/outlander-sport-red-compressor.png"),
          angleView: require("../../../static/images/carcuts/mitsubishi/angle-view/outlander-sport-19.png"),
          trims: ["2.0 S", "2.0 ES", "2.0 LE", "2.0 SE", "SE Special Edition", "2.4 GT", "GT Special Edition"]
        },
      ],
      trucks: [],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/mitsubishi/lifestyle/Eclipse-Cross-2018.jpg"),
        sedanImage: require("../../../static/images/carcuts/mitsubishi/lifestyle/mirage.jpg"),
        suvImage: require("../../../static/images/carcuts/mitsubishi/lifestyle/OutlanderSport-22.jpg"),
        truckImage: require("../../../static/images/carcuts/mitsubishi/lifestyle/OutlanderPHEV-22.jpg")
      },
      videoLink: [
        "https://player.vimeo.com/external/389599096.hd.mp4?s=8720a475af427975b28b321217df4ff2d953482d&profile_id=175"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/mitsu-New.png"), require("../../../static/images/buttons/round-buttons/mitsu-Used.png"), require("../../../static/images/buttons/round-buttons/mitsu-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/mitsu-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/mitsu-new.png"), require("../../../static/images/buttons/browse-buttons/mitsu-used.png"), require("../../../static/images/buttons/browse-buttons/mitsu-service.png"), require("../../../static/images/buttons/browse-buttons/mitsu-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/mitsu01.png"), require("../../../static/images/buttons/swoop-icons/mitsu03.png"), require("../../../static/images/buttons/swoop-icons/mitsu02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/mitsubishi/CM-MS-24-Mitsubishi-Established.jpg"), require("../../../static/images/banners/mitsubishi/CM-MS-24-Mitsubishi-Lifestyle.jpg"), require("../../../static/images/banners/mitsubishi/CM-MS-24-Mitsubishi-Modern.jpg"), require("../../../static/images/banners/mitsubishi/CM-MS-24-Mitsubishi-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/mitsubishi/SOKAL-SRS-121021-Eclipse-Established.jpeg"), require("../../../static/images/banners/mitsubishi/SOKAL-SRS-121021-Eclipse-Lifestyle.jpeg"), require("../../../static/images/banners/mitsubishi/SOKAL-SRS-121021-Eclipse-Modern.jpeg"), require("../../../static/images/banners/mitsubishi/SOKAL-SRS-121021-Eclipse-Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-mitsubishi.png"),
        require("../../../static/images/buttons/logos/dd-logo-mistu-w.png")
      ]
    },
   colors: {
      "--primary-color": "#ed2d2d",
      "--primary-dark": "#221e20",
      "--primary-light": "#fff",
      "--secondary-color": "#ed2d2d",
      "--secondary-dark": "#000",
      "--secondary-light": "#b7bebf",
    },
    fonts: {
      "--heading-text": "Verdana, Arial, sans-serif",
      "--subheading-text": "Verdana, Arial, sans-serif",
      "--body-text": "Verdana, Arial, sans-serif",
      "--bold-text": "Verdana, Arial, sans-serif"
    }
  })
}


export default mitsubishi